import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Scrollbar } from 'react-scrollbars-custom';

function RankCriteriaTile({ nextRank, t }) {
  return (
    <>
      {nextRank?.criteriaDetails && (
        <Carousel data-bs-theme="dark" style={{ height: "200px" }}>
          {nextRank.criteriaDetails.map((item, index) => (
            <Carousel.Item key={index}>
              <div style={{
                padding: '0px 100px 0px 100px',
                textAlign: 'center',
                maxHeight: "150px",
              }}>
                {/* Title */}
                <div style={{ background: "white", position: "sticky", top: "0" }}>
                  <h5 style={{ fontWeight: '600', marginBottom: '12px' }}>
                    {t(item.name)}
                  </h5>
                </div>

                <Scrollbar style={{
                  height: 100,
                  marginRight: '0px', // Remove negative margin
                  paddingRight: '8px' // Add padding instead
                }}

                  thumbYProps={{
                    style: {
                      backgroundColor: '#954cea', // Blue color for thumb
                      borderRadius: '4px'
                    }
                  }}
                  trackYProps={{
                    style: {
                      backgroundColor: '#d9dad8', // Light gray for track
                      borderRadius: '4px',
                      width: '8px'
                    }
                  }}
                >
                  {/* Content */}
                  {item.name === "leg-carry" ? (
                    <>
                      <p >
                        Requires <span className='rightSide_top_user_dropdown_package'>{item.value[0]}</span> & <span className='rightSide_top_user_dropdown_package'>{item.value[1]}</span> in Left or Right
                        
                      </p>

                      <p style={{  /* fontSize: 'smaller' */ }}>
                        Achieved <span className='rightSide_top_user_dropdown_package'>{item.acheived.left}</span> in Left & <span className='rightSide_top_user_dropdown_package'>{item.acheived.right}</span> in Right
                      </p>
                    </>
                  ) : item.name === "downline-rank-count" ? (
                    <div>
                      {item.value.map((e, idx) => (
                        <>
                        
                        <p key={idx} style={{  /* fontSize: 'smaller' */ color: e.acheived >= e.value ? "  #1f7a1f" : "#4d4e4b" }}>
                        {e.acheived>=e.value &&
                          <span><i class="fa-solid fa-circle-check" style={{"color": "#4e9a06"}}></i>{" "}</span>
                        }
                          {`${e.label}: ${e.acheived} / ${e.value}`}
                        </p>
                        </>
                      ))}
                    </div>
                  ) : (
                    <p style={{  /* fontSize: 'smaller'  */ }}>
                      Achieved <span className='rightSide_top_user_dropdown_package'>{item.acheived}</span> Of <span className='rightSide_top_user_dropdown_package'>{item.value}</span>
                    </p>
                  )}
                </Scrollbar>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </>
  );
}

export default RankCriteriaTile;